import {Checkbox} from "@mantine/core";
import slugify from "@sindresorhus/slugify";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import type {ChecklistRelatedItem, CollectionDataResponse} from "../../types";
import {TOPIC_TYPE_PATHS} from "../../paths";
import styles from "../checklist-documents-list.module.css";

type DocumentGeneratorRefProps = {
    relatedItem: ChecklistRelatedItem;
    collectionData?: CollectionDataResponse;
    checklistMeta?: {topictypeId: string; name: string; topicId: string};
    onToggle?: (topicId: string, selected: boolean) => void;
    checklistBasePath?: string;
};

const buildDocUrl = (item: ChecklistRelatedItem): string => {
    const typePath =
        TOPIC_TYPE_PATHS[
            Number(item.topictypeId) as keyof typeof TOPIC_TYPE_PATHS
        ] ?? "unknown";
    return `/${typePath}/${slugify(item.name)}/${item.topicId}`;
};

export const DocumentGeneratorRef = ({
    relatedItem,
    collectionData,
    onToggle,
    checklistBasePath,
}: DocumentGeneratorRefProps) => {
    const {t} = useTranslation();
    const isSelected =
        collectionData?.documents?.some(
            (d) => d.topicId === relatedItem.topicId,
        ) ?? false;

    const collectionSuffix =
        collectionData?.metadata?.collectionId
            ? `/utfylling/${slugify(collectionData.metadata.name ?? "utfylling")}/${collectionData.metadata.collectionId}`
            : "";

    const url = checklistBasePath
        ? `${checklistBasePath}/dokument/${slugify(relatedItem.name)}/${relatedItem.topicId}${collectionSuffix}`
        : buildDocUrl(relatedItem);

    if (!onToggle) {
        // Plain link mode (used from CheckItem related section)
        return (
            <li>
                <Link to={url} className={styles.documentLink}>
                    {relatedItem.name}
                </Link>
            </li>
        );
    }

    return (
        <div className={styles.documentRow}>
            <Checkbox
                size="xs"
                checked={isSelected}
                onChange={() => onToggle(relatedItem.topicId, !isSelected)}
                title={
                    isSelected
                        ? t("Info.RemoveFromGeneration")
                        : t("Info.IncludeInGeneration")
                }
            />
            <Link to={url} className={styles.documentLink}>
                {relatedItem.name}
            </Link>
        </div>
    );
};
